/**
 * index.js
 * Created by michaelbray on 6/22/17.
 */

import alertsReducer from './navigation/alertsNotificationReducer';
import modalReducer from './navigation/modalReducer';
import loginReducer from './navigation/loginReducer';
import recaptchaReducer from './recaptcha/recaptchaReducer';
import searchCriteriaReducers from './search/searchCriteriaReducers';
import searchSuggestionsReducers from './search/searchSuggestionsReducers';
import notificationReducer from './notification/notificationReducer';
import cartItemsReducers from './cart/cartItemsReducer';
import recommendationReducer from './recommendations/recommendationReducer';
import { slugsReducer } from './slugs/slugsReducers';
import { assetsReducer } from './assets/assetsReducers';

const sarsaparillaReducers = {
    alertsNotification: alertsReducer,
    modal: modalReducer,
    auth: loginReducer,
    recommendations: recommendationReducer,
    search: searchCriteriaReducers,
    searchSuggestions: searchSuggestionsReducers,
    cart: cartItemsReducers,
    recaptcha: recaptchaReducer,
    notifications: notificationReducer,
    slugs: slugsReducer,
    asset: assetsReducer,
};

export default sarsaparillaReducers;
